import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { LogoLoading } from 'ensightful-koala-ui';
import { isEmpty } from 'lodash';
import styled from 'styled-components';

// import OptionalComponents from 'app/OptionalComponents';
import ProviderWrapper from 'app/ProviderWrapper';
import { useAuth } from 'contexts/auth';
import withPlatformRouting from 'hoc/withPlatformRouting';
import Header from 'parts/Header';

const PageWrapper = styled.div`
    width: 100vw;
    height: 100%;
    overscroll-behavior-y: none;
`;

const HeaderWrapper = styled('div')(({ theme }) => {
    return {
        position: 'relative',
        top: 0,
        zIndex: theme.zIndex.drawer + 1,
        borderBottom: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: '100%',
        height: '64px',
        minHeight: '64px',
        maxHeight: '64px',
        background: 'white',
    };
});

const BodyWrapper = styled.div`
    display: flex;
    justify-content: center;
    position: absolute;
    top: ${(props) => (props.hasHeader ? '0' : '64px')};
    width: 100%;
    height: ${(props) => (props.hasHeader ? '100vh' : 'calc(100vh - 64px)')};
    background-color: #fafafa;
    overflow: auto;
`;

axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
axios.interceptors.response.use(
    ({ data }) => data,
    ({ response = {} }) => {
        if (response.status === 401) {
            localStorage.removeItem('auth_token');
            axios.defaults.headers.common.Authorization = undefined;
            window.location.href = '/';
        }
        return Promise.reject(response);
    }
);

const App = () => {
    const { loading, auth } = useAuth();
    const location = useLocation();

    const popUpChatRef = useRef(null);

    const noHeaderRoutes = [
        '/components',
        '/accepted-invitation',
        '/course-set-up',
        '/lti-incomplete',
        '/profile-setup',
        '/survey',
    ];

    return loading ? (
        <LogoLoading />
    ) : (
        <ProviderWrapper>
            <PageWrapper>
                {!noHeaderRoutes.includes(location.pathname) && !isEmpty(auth) && (
                    <HeaderWrapper>
                        <Header />
                    </HeaderWrapper>
                )}
                <BodyWrapper hasHeader={noHeaderRoutes.includes(location.pathname) || isEmpty(auth)}>
                    {withPlatformRouting({ popUpChatRef })}
                    {/* <OptionalComponents popUpChatRef={popUpChatRef} /> */}
                </BodyWrapper>
            </PageWrapper>
        </ProviderWrapper>
    );
};

export default App;
